import { ROUTE_CONFIG } from "@/routes/config";

import { ContactsTab } from "../schema/contacts";
import { normalizeContactsTab } from "./normalizeContactsTab";

const LEGACY_TAB_TARGETS: Partial<Record<ContactsTab, string>> = {
	[ContactsTab.COMPANIES]: ROUTE_CONFIG.CONTACTS_COMPANIES,
	[ContactsTab.COMPETITORS]: ROUTE_CONFIG.DO_NOT_CONTACT_COMPETITORS,
	[ContactsTab.BLACKLIST]: ROUTE_CONFIG.DO_NOT_CONTACT_BLACKLIST,
};

/**
 * The Contacts tabs became routed pages (PREC-3781), but `?tab=` links live on
 * in bookmarks, notification e-mails and older extension builds. Maps a legacy
 * search string to the tab's new location — preserving every other param
 * (`competitors_page`, `prospectId`, …) — or null when the URL already means
 * the Contacts view itself (no tab, CONTACTS, or an unknown value).
 */
export const resolveLegacyContactsTabTarget = (
	search: string
): { pathname: string; search: string } | null => {
	const params = new URLSearchParams(search);
	const rawTab = params.get("tab");

	if (rawTab === null) {
		return null;
	}

	const target = LEGACY_TAB_TARGETS[normalizeContactsTab(rawTab)];

	if (!target) {
		return null;
	}

	params.delete("tab");

	return { pathname: target, search: params.toString() };
};
